<template>
	<div class="swiper-box">
		<van-swipe @change="onChange" :autoplay="300000" indicator-color="white">
			<van-swipe-item v-for="pic in list" :key="pic">
				<van-image fit="cover" width="100vw" :src="pic" />
			</van-swipe-item>
			<template #indicator>
				<div class="custom-indicator">
					<div class="current">{{ current + 1 }}</div>
					<div class="all-num">{{ list.length }}</div>
				</div>
			</template>
		</van-swipe>
	</div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import '@/assets/css/swiper.min.css'
export default {
	name: 'MySwiper',
	components: {
		swiper,
		swiperSlide,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			current: 0,
		}
	},
	mounted() { },
	methods: {
		onChange(index) {
			this.current = index
		},
	},
}
</script>

<style lang="less" scoped>
.swiper-box {
	width: 100vw;
	height: 375px;
	box-sizing: border-box;

	.custom-indicator {
		position: absolute;
		right: 16px;
		bottom: 16px;
		width: 34px;
		height: 18px;
		background: rgba(0, 0, 0, 0.3);
		border-radius: 9px;
		font-size: 12px;
		font-family: 'DINA';
		font-weight: bold;
		color: #ffffff;
		line-height: 18px;
		display: flex;

		.current {
			width: 18px;
			height: 18px;
			border-radius: 50%;
			text-align: center;
			background: rgba(0, 0, 0, 0.2);
		}

		.all-num {
			flex: 1;
			text-align: center;
			padding-right: 2px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/product/components/Swiper.vue